
// Test data for Level 2 Iron Training

export const ironTests = [
  {
    id: "iron-long",
    title: "Fers longs",
    description: "Autour d'un trou, sur le green d'entrainement ou sur le parcours choisissez un trou et matérialisez à l'aide de tees 4 cercles de 2, 4, 6, 10 m. Taper 10 balles avec les fers 4, 5, 6 vers une cible à 130 m, noter les points selon la précision.",
    icon: "🏌️‍♂️",
    distance: "130m"
  },
  {
    id: "iron-mid",
    title: "Fers moyens",
    description: "Autour d'un trou, sur le green d'entrainement ou sur le parcours choisissez un trou et matérialisez à l'aide de tees 4 cercles de 2, 4, 6, 10 m. Taper 10 balles avec les fers de votre choix vers une cible à 80 m, noter les points selon la précision.",
    icon: "🏌️‍♂️",
    distance: "80m"
  },
  {
    id: "iron-green-attack-100",
    title: "Attaque de green 100 m",
    description: "Sur le parcours choisissez un trou et imaginez 4 zones cibles matérialisées par des cercles de 2, 4, 6, 10 m. Vous partagez le green en 2 zones : gauche, droite. L'exercice consiste à taper 10 balles depuis la distance de 100 m, vous notez les points en fonction des cercles d'arrivée et les tendances à gauche, à droite du green.",
    icon: "🎯",
    distance: "100m"
  }
];
